import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { getWorkflowScenarioVersions } from "../../../api";
import { formatWorkflowDate } from "../format";

interface VersionsModalProps {
    show: boolean;
    scenarioUuid: string | null;
    currentVersion: number;
    readOnly: boolean;
    onRestore: (version: number) => void;
    onClose: () => void;
}

/** Saved versions of the blueprint; restoring one saves it as a new version. */
const VersionsModal = ({ show, scenarioUuid, currentVersion, readOnly, onRestore, onClose }: VersionsModalProps) => {
    const { t } = useTranslation(['workflow']);
    const [items, setItems] = useState<Array<{ version: number; createdAt?: string }>>([]);
    const [confirm, setConfirm] = useState<number | null>(null);

    useEffect(() => {
        if (show && scenarioUuid) {
            setConfirm(null);
            getWorkflowScenarioVersions(scenarioUuid).then((r: any) => setItems(r?.items || [])).catch(() => setItems([]));
        }
    }, [show, scenarioUuid]);

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton><Modal.Title>{t('workflow:versions')}</Modal.Title></Modal.Header>
            <Modal.Body>
                {items.length === 0 && <div className="text-muted">{t('workflow:noVersions')}</div>}
                <ul className="list-group">
                    {items.map((v) => (
                        <li key={v.version} className="list-group-item d-flex align-items-center">
                            <span className="fw-semibold me-2">v{v.version}</span>
                            <span className="text-muted small">{formatWorkflowDate(v.createdAt)}</span>
                            {v.version === currentVersion
                                ? <span className="badge badge-soft-success ms-auto">{t('workflow:current')}</span>
                                : !readOnly && (confirm === v.version
                                    ? <button type="button" className="btn btn-sm btn-warning ms-auto" onClick={() => onRestore(v.version)}>{t('workflow:confirmRestore')}</button>
                                    : <button type="button" className="btn btn-sm btn-light ms-auto" onClick={() => setConfirm(v.version)}>{t('workflow:restore')}</button>)
                            }
                        </li>
                    ))}
                </ul>
            </Modal.Body>
        </Modal>
    );
};

export default VersionsModal;
